import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function ThankYou() {
  const navigate = useNavigate();
  const handleGoBack = () => {
    console.log("handle back");
    navigate(`/`);
  };

  useEffect(() => {
    // PO2-TY-Duplicate tags
    window.gtag('event', 'conversion', {'send_to': 'AW-10917910622/zaEsCNCK_78cEN6wiNYo'});
    window.fbq('init', '{1584375811875352}');
    window.fbq('track', 'PO2-TY-Duplicate');
  }, []);

  return (
    <>
      <section className="thankyou">
        <div className="container">
          <div className="row">
            <div className="col-md-6 order-md-2">
              <div className="content">
                {/* <h4>Thank you.</h4> */}
                <h4>Your application is already with us.</h4>
                <p>
                  Thank you for showing interest in <br /> ICICI Bank Probationary Officer Program.
                </p>
                <p>Wishing you all the best.</p>
              </div>
            </div>
            <div className="col-md-6 order-md-1">
              <div className="successfulimg"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ThankYou;
